import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const unstageWorkOrderComponentInputSchema = z.object({
    workOrderItemId: requiredUuidString('Component is required.', 'Invalid component selection.'),
    tagId: requiredUuidString('Batch is required.', 'Invalid batch selection.'),
});
//# sourceMappingURL=unstage-component-input.js.map